import { Answer as GDSAnswer, Question as GDSQuestion } from '../gds-api-client';

export type Answer = GDSAnswer;
export type Question = GDSQuestion;

export interface Wedding {
  id: string;
}

export interface Address {
  street1: string | null;
  street2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  country: string | null;
  fullAddress: string | null;
}

export interface Person {
  id?: string;
  isLeader: boolean | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  email: string | null;
  invitations: Invitation[];
}

export interface Event {
  id: string;
  type: string;
  name: string;
  requireRsvp: boolean;
  visible: boolean;
  questions: Question[] | null;
}

export interface Household {
  id?: string;
  description: string | null;
  rsvpNote: string | null;
  coupleNote: string | null;
  address: Address | null;
  people: Person[];
  answers?: Answer[] | null;
}

export interface GuestModalProps {
  isOpen: boolean;
  overlay?: boolean | true;
  onClose: () => void;
  onSuccess?: (data: Household) => void;
  onBulkSuccess?: (data: Household[]) => void;
  onDelete: (id: string) => void;
  events: Event[];
  wedding: Wedding;
  selectedEvent?: Event;
  household?: Household;
  householdsList?: Household[];
  analyticsObject?: object;
  guestWeddingQuestions: GuestWeddingQuestions;
  showError: () => void;
  clearError: () => void;
  defaultView?: TabViews;
  contactFocus?: string;
  topLabel?: string;
  focusOn?: FocusOn;
}

export interface Invitation {
  id?: string;
  eventId: string;
  invitationSent?: boolean | null;
  rsvp?: boolean | null;
  meal?: string | null;
  gift?: string | null;
  thankYouSent?: boolean | null;
  answers?: Answer[] | null;
}

export enum FocusOn {
  all = 'all',
  email = 'email',
  phone = 'phone',
}

export enum ModalType {
  add = 'add',
  edit = 'edit',
}

export interface FormProps extends Household {
  invitations: Invitation[];
}

export type BulkFormProps = Household[];

export interface AddressComponent {
  types: string[];
  short_name: string;
  long_name: string;
}
export interface Place {
  street_number: string;
  route: string;
  locality: string;
  sublocality: string;
  administrative_area_level_1: string;
  country: string;
  postal_code: string;
}

export type GuestWeddingQuestions = Question[] | null;

export type TabViews = 'main' | 'responses';
